import { useQuery } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

export const useNutror = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['nutror'],
    queryFn: async () => {
      const result = await apiServiceProxy.get<{
        packages: { id: number; title: string; hash: string }[];
        courses: { id: number; title: string; hash: string }[];
      }>('/deliveryproviders/nutror');
      const data = result.data;
      return {
        packages: data.packages ?? [],
        courses: data.courses ?? []
      };
    }
  });

  return {
    packages: data?.packages ?? [],
    courses: data?.courses ?? [],
    isLoading,
    error
  };
};
